export default __webpack_public_path__ + "static/media/ellipse_solid.acefd151.png";